<template>
    <span>
        <div class="content-wrap content-wrap--wide">
      <div class="sidebar sidebar--wide" id="sidebar" style="cursor:pointer" v-on:click="backToStart()">
        <header id="header" class="header">
          <div class="container">
            <div class="header__wrap">
              <div class="header__logo">
                <a href="/"><img :src="logoPath() + '/templates/agila/images/logo.png'" alt="Agila Haustlerversicherung" /></a>
              </div>
              <div class="header__link">
                <a href="#" id="backlink" class="back-link"><span class="back-link__icon icon-left-arrow"></span>Zurück
                  zur Seite</a>
              </div>
            </div>
          </div>
        </header>
        <div class="bg-cover-block">
          <img :src="getImage" alt="aside background" />
        </div>
      </div>
      <main id="main">
        <section class="content-section content-section--wide bg-blue">
          <span class="loader">
            <span style="width: 100%"></span>
          </span>
          <div class="container container--wide">
            <div class="content lesspad">
              <div class="content__topbar" id="topbar"></div>
              <div class="content__subheading">
                <span>Vielen Dank für Ihr Vertrauen!</span>
              </div>
              <div class="content__heading content__heading--wide">
                <h1>
                  Sie haben für {{ pettype }} {{ lead.petname }} {{ applicationType }}  {{ displayContracts }} eingereicht.
                </h1>
              </div>
              <div class="content__info">
                <p v-html="thankYouNotice"></p>
              </div>
              <a @click="reloadLeads()" class="content__btn btn btn--green over">Weiteren Vertrag abschließen</a>
              <div class="nps_banner"><div class="nps_text">Wie viele Pfoten<br/>geben Sie uns?</div><a href="https://feedback.agila.de/np/antrag" target="_blank">Jetzt abstimmen</a></div>

            </div>
            <section>
              <div class="general-info__client-app client-app">
                <h2 class="client-app__title">
                  Kennen Sie schon unsere AGILA Kunden-App?
                </h2>
                <div class="content__info">
                  <p>
                    Jetzt ganz einfach Ihre Verträge in der AGILA App verwalten und Rechnungen oder
                    Haftpflichtschäden schnell & einfach einreichen.
                  </p>
                  <p>
                    <a href="/service/vertragsdaten/kunden-app" class="more_info">Mehr erfahren</a>
                  </p>
                </div>
              </div>
              <div class="general-info__app-store app-store">
                <ul class="app-store__list">
                  <li class="app-store__item">
                    <a href="https://apps.apple.com/de/app/agila-kunden-app/id1496497379?utm_source=website&utm_medium=App-Badge%20iOS&utm_campaign=AGILA%20Kunden-App%22" class="app-store__link" target="_blank">
                      <img class="app-store__img" :src="imagePath('images/app-store.png')" :srcset="imagePath('images/app-store@2x.png 2x')" alt="Download on App Store" />
                    </a>
                  </li>
                  <li class="app-store__item">
                    <a href="https://play.google.com/store/apps/details?id=de.agila.app.customer&gl=DE&utm_source=website&utm_medium=App-Badge+Android&utm_campaign=AGILA+Kunden-App&pli=1" class="app-store__link" target="_blank">
                      <img class="app-store__img" :src="imagePath('images/google-play.png')" :srcset="imagePath('images/google-play@2x.png 2x')" alt="Get it on Google Play" />
                    </a>
                  </li>
                </ul>
              </div>
            </section>


                <img v-if="isAwin" border="0" height="0" v-bind:src="'https://www.awin1.com/sread.img?tt=ns&tv=2&merchant=9295&amount=1&ch=aw&parts=' + abbr + ':1&ref=' + trackingCode + '&cr=EUR&testmode=' + testmode" style="display: none;" width="0">
                <img v-if="isFA" v-bind:src="'https://www.financeads.net/tl.php?p=317&oid=' + orderID + '&ocategory=' + ocategory + '&s_id='" alt="" border="0" width="0" height="0">
          </div>
        </section>
      </main>
    </div>
    <div style="width:100%; background: linear-gradient(to right, rgb(246, 250, 255) 50%, white 50%);">
    <a href="https://talesandtails.de/discount/AGILA?redirect=%2Fproducts%2Fagila-paket&amp;utm_source=agila&amp;utm_medium=banner&amp;utm_campaign=nc" target="_blank" rel="nofollow noopener noreferrer" class="talesTails"><img data-lazy-src="//www.agila.de/images/AGILA_TalesTails_Banner_01B_NEU.jpg" alt="TalesTails" src="//www.agila.de/images/AGILA_TalesTails_Banner_01B_NEU.jpg" style="width: 1200px;"></a>
    </div>
    </span>
</template>

<script>
import dialog from "@/helpers/dialog";
import AgModalAttention from "@/components/Modal/Attention.vue";
import {setCampaign} from "../vars";

export default ({
    props: {
        registry: {
            type: Object,
            default() {
                return {}
        }},
        lead: {
            type: Object,
            default() {
                return {}
        }}
    },
    data: () => ({
      isAwin: false,
      isFA: false,
      testmode: 0,
      abbr: '',
      trackingCode: '',
      orderID: '',
      applicationType: 'einen Antrag für den',
      thankYouNotice: 'Nach erfolgreicher Prüfung erhalten Sie die Vertragsunterlagen per <span class="nowrap">E-Mail</span>. <a href="/">Hier</a> geht es zurück zur Startseite.',
      ocategory: '',
      contract: { 'TK': 'Gesundheitspass', 'HP': 'Haftpflicht', 'OP': 'OP-Kosten-Versicherung', 'KO': 'Kombi-Versicherung'}
    }),
    mounted: function () {
      history.pushState(null, null, '#' + window.location.hash.split('#')[1] + '#' + 'bestaetigung')
      setCampaign(false);
      document.cookie = 'welcome=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

      if (this.registry.cc && (this.registry.cc.includes('zp') || this.registry.cc.includes('all') || this.registry.cc.includes('marketing'))
          && (this.lead.brokerID == '' || this.lead.brokerID == '21' || this.lead.brokerID == '22')) {

          if (this.lead.brokerID == '22') {

            this.orderID = this.getTrackingId(this.registry.productByID[this.lead.productActive].abbreviation)
            let contractList	= {
                'OP': 'OPSchutz',
                'TK': 'Tierkrankenversicherung',
                'KO': 'kombi',
                'HP': 'Haftpflicht'
            };
            this.ocategory = contractList[this.registry.productByID[this.lead.productActive].abbreviation.substr(0,2)]
            this.isFA = true;
            window.faOrderID = this.orderID ;
            window.faProgramID = "317";
            window.faCategory = this.ocategory;
            let fasscript = document.createElement('script')
            fasscript.setAttribute('src', 'https://fat.financeads.net/fpc.js')
            document.getElementsByTagName("body")[0].appendChild(fasscript)
            this.thankYouNotice = 'Bitte beachten Sie, dass derzeit noch kein Schutz für Ihr Tier besteht. Wir haben Ihnen eine E-Mail mit einem Bestätigungslink gesendet. Bitte klicken Sie innerhalb der nächsten 3 Tage auf den Link in der <span class="nowrap">E-Mail</span>, um den Abschluss Ihrer Versicherung bei AGILA zu bestätigen. <a href="/">Hier</a> geht es zurück zur Startseite.';

            return;
          }

          const zeroPad = (num, places) => String(num).padStart(places, '0')

          let cusDate = new Date(this.lead.birthday)

          let dateObj = new Date();
          this.abbr = this.registry.productByID[this.lead.productActive].abbreviation.substr(0,2)

          this.trackingCode = dateObj.getFullYear() + zeroPad((dateObj.getUTCMonth() + 1), 2) + zeroPad(dateObj.getUTCDate(), 2) + '-';
          this.trackingCode += (this.lead.firstname.substr(0, 2) + this.lead.lastname.substr(0, 2)).toLowerCase() + '-';
          this.trackingCode += zeroPad(cusDate.getDate(), 2) +  zeroPad((cusDate.getMonth()+1), 2) + cusDate.getFullYear() + '-';

          if (this.lead.crossselling != '') {
            this.trackingCode += 'KOMBI_' + this.abbr + '_' + this.registry.productByID[this.lead.crossselling].abbreviation.substring(0, 2) + '_Versicherung';


          } else {
            this.trackingCode += this.contract[this.abbr];
          }

          window.AWIN = {};
          window.AWIN.Tracking = {};
          window.AWIN.Tracking.Sale = {};

          window.AWIN.Tracking.Sale.amount = "1";
          window.AWIN.Tracking.Sale.channel = "aw";
          window.AWIN.Tracking.Sale.orderRef = this.trackingCode;
          window.AWIN.Tracking.Sale.parts = this.abbr + ":1";
          window.AWIN.Tracking.Sale.currency = "EUR";
          window.AWIN.Tracking.Sale.voucher = "";
          window.AWIN.Tracking.Sale.test = this.testmode;
/* eslint-disable no-unused-vars */
          window.awin_pagetype="checkout";
          window.awin_products = [
            { "identifier": this.abbr, "amount": this.lead.productPrice, "currency": "EUR", "quantity": "1" }
          ];
          window.awin_transaction = this.trackingCode;
          window.awin_total_amount = this.lead.productPrice;
          window.awin_total_currency = "EUR";
          window.awin_language = "de";
/* eslint-enable no-unused-vars */
          this.isAwin = true;
          var awinScript = document.createElement('script')
          awinScript.setAttribute("defer", "defer");
          awinScript.setAttribute('src', 'https://www.dwin1.com/9295.js')
          awinScript.type = "text/javascript";
          document.getElementsByTagName("body")[0].appendChild(awinScript)

          if (this.lead.brokerID == '21') {
            this.thankYouNotice = 'Bitte beachten Sie, dass derzeit noch kein Schutz für Ihr Tier besteht. Wir haben Ihnen eine E-Mail mit einem Bestätigungslink gesendet. Bitte klicken Sie innerhalb der nächsten 3 Tage auf den Link in der <span class="nowrap">E-Mail</span>, um den Abschluss Ihrer Versicherung bei AGILA zu bestätigen.';
          }
      }

      if (
          this.registry.cc &&
          (this.registry.cc.includes("gat") ||
              this.registry.cc.includes("all") ||
              this.registry.cc.includes("marketing"))
      ) {
        dialog.component(AgModalAttention).then(attention => {
          if (attention) {
            fetch(process.env.VUE_APP_COMMON_API_URL + 'metrics', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Client-Key': process.env.VUE_APP_COMMON_API_KEY
              },
              body: JSON.stringify({
                "index": "survey-attentions-" + process.env.NODE_ENV,
                "value": {
                  "attentions": [attention],
                  "pet": {
                    tierart: this.lead.race == "1" ? "Hund" : "Katze",
                    rasse: this.lead.breed,
                    alter: this.lead.petbirthday,
                    geschlecht: this.lead.petgender,
                  },
                  "products": this.getTrackingProductItems(this.lead.crossselling, this.lead)
                },
                "tags": {
                  "origin": "antragsstrecke"
                }
              })
            });
          }
        })
      }

      if (this.lead.doContract !== undefined && this.lead.doContract !== false) {
        this.thankYouNotice = 'Nach erfolgreicher Prüfung erhalten Sie die Vertragsunterlagen per <span class="nowrap">E-Mail</span>. <a href="/">Hier</a> geht es zurück zur Startseite.',
        this.applicationType = 'eine Tarifanpassung in den '
        this.lead.doContract = false
      }

      if (['99901', '99902', '99903', '99904', '99905', '99906', '99907'].includes(this.lead.brokerID) && (this.lead.hashR == undefined || this.lead.hashR == false)) {
        this.thankYouNotice = 'Bitte beachten Sie, dass derzeit noch kein Schutz für Ihr Tier besteht. Wir haben Ihnen eine E-Mail mit einem Bestätigungslink gesendet. Bitte klicken Sie innerhalb der nächsten 3 Tage auf den Link in der <span class="nowrap">E-Mail</span>, um den Abschluss Ihrer Versicherung bei AGILA zu bestätigen. <a href="/">Hier</a> geht es zurück zur Startseite.';

      }

      try {
        if (this.registry.cc && this.registry.cc.includes("ad") && window._aut) {
          window._aut.callTagUrl('https://ad1.adfarm1.adition.com/tagging?type=image&network=3341&gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_39}&tag[agilaRet.demark]');
        }
        if (this.registry.cc && this.registry.cc.includes("rp") && window.__rpta) {
          window.__rpta.push('event', 'purchase');
        }
      } catch (e) {
        console.error(e);
      }

    /*  var awMastertag = document.createElement("script");
awMastertag.setAttribute("defer", "defer");
awMastertag.src = "https://www.dwin1.com/1001.js";
awMastertag.type = "text/javascript";
document.getElementsByTagName("body")[0].appendChild(awMastertag);*/
    },
    computed: {
      displayContracts () {
        let out = this.registry.productByID[this.lead.productActive].title

        if (this.lead.combi != '') {
          let ac = ' und '

          if (this.lead.crossselling != '') {
              ac = ', '
          }

          out += ac + ' einen ' + this.registry.productByID[this.lead.combi].title
        }

        if (this.lead.crossselling != '') {
          out += ' und einen ' + this.registry.productByID[this.lead.crossselling].title
        }

        return out
      },
      getBackLink() {
        return window.location.pathname + '#' + window.location.hash.split('#')[1]
      },

      getImage() {
        let slash = '';

        if (window.location.host.includes('localhost')) {
          slash = '/'
        }

        const img = { '1': 'images/agila-img-dog-637x987px.png',
                      '2': 'images/agila-img-cat-637x987px.png'}
        return slash + img[this.lead.race]
      },
      pettype() {
        const race = ['', 'Ihren Hund', 'Ihre Katze']
        return race[this.lead.race]
      }
    },
    methods: {
      reloadLeads() {
        window.location.reload();
       // return window.location.pathname + '#' + window.location.hash.split('#')[1] + '#tier'
        // return '//' + window.location.hostname + window.location.pathname + '#' + window.location.hash.split('#')[1] + '#tier'
      },
      logoPath() {
        return process.env.VUE_APP_ENV_URL;
      },
      backToStart() {
        window.location.href='/';
      },
      imagePath(image){
        let slash = '';

        if (window.location.host.includes('localhost')) {
          slash = '/'
        }

        return slash + image
      },

      setPlaceTo0() {
        this.$parent.setPlace(0)
      },
      getTrackingId(abbr) {
        abbr = abbr.substr(0, 2)

        let birthdate = new Date(this.lead.birthday);
        let birthMonth 	= String(birthdate.getMonth() + 1).padStart(2, '0');
        let birthDay 		= String(birthdate.getDate()).padStart(2, '0');
        let birthYear 		= birthdate.getFullYear();

        let dateObj = new Date();
        let month = dateObj.getUTCMonth() + 1; //months from 1-12
        let day = dateObj.getUTCDate();
        let year = dateObj.getUTCFullYear();

        return year + month + day + "-" + this.lead.firstname.toLowerCase().substr(0, 2) + '-' + this.lead.lastname.toLowerCase().substr(0, 2) + '-' + birthDay + birthMonth + birthYear + '-' + this.contract[abbr]

      }
    }
})
</script>
<style scoped>
.content-section--wide  .content__subheading {
  font-size:38px;
  line-height:38px;
}
.content.lesspad {
  padding-bottom:50px;
}
.more_info {
  font-size:16px;
  color: #004ea0;
  border-bottom: 4px solid #C0E1FF;
  font-weight: bold;
}
.over {
  cursor: pointer;
}
.talesTails {
  margin: 0px auto;display: block;text-align: center;position:relative;max-width: 1200px;
}
@media (max-width: 767px) {
	.talesTails {
    margin: 20px auto 100px auto;
  }
}

</style>
